const isLocal = window.location.hostname === "localhost";

export const API_URL = isLocal ? "http://localhost:3000" : "https://www.wjtolive.com:3000";